import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Card, Spinner } from "react-bootstrap";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import { Eye, EyeOff, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { FaTicketAlt } from "react-icons/fa";

const SellerDetail = () => {
  const { uniqueid } = useParams();
  const [sellerData, setSellerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSellerDetail = async () => {
      try {
        const response = await axios.get(
          `${baseurl}getSellerByUniqueId/${uniqueid}`
        );
        setSellerData(response.data);
      } catch (error) {
        console.error("Error fetching seller detail:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSellerDetail();
  }, [uniqueid]);

  const handleDeleteAccount = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the seller account!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await axios.delete(
          `${baseurl}deleteSellerById/${sellerData.seller.id}`
        );
        if (response.data.status === "success") {
          Swal.fire(
            "Deleted!",
            "The seller account has been deleted.",
            "success"
          );
          // Optionally redirect or refresh
          navigate(-1);
        } else {
          Swal.fire(
            "Error",
            response.data.message || "Something went wrong.",
            "error"
          );
        }
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire("Error", "Failed to delete account.", "error");
      }
    }
  };




  const handleApproveAccount = async () => {
  const confirm = await Swal.fire({
    title: "Are you sure?",
    text: "This will approve the seller account!",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, approve it!",
  });

  if (confirm.isConfirmed) {
    try {
      const response = await axios.put(
        `${baseurl}approveSellerById/${sellerData.seller.id}`,
        { approval: true } // if your API expects a body
      );

      if (response.data.status === "success") {
        Swal.fire(
          "Approved!",
          "The seller account has been approved.",
          "success"
        );
        // Optionally refresh the page or update state
        // Example: refetch seller data
        // fetchSellerData(); 
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Something went wrong.",
          "error"
        );
      }
    } catch (error) {
      console.error("Approve error:", error);
      Swal.fire("Error", "Failed to approve account.", "error");
    }
  }
};





  const handleDisabledAccount = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will Disable the seller account!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Disable it!",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await axios.post(
          `${baseurl}disableSellerById/${sellerData.seller.id}`
        );
        if (response.data.status === "success") {
          Swal.fire(
            "Deleted!",
            "The seller account has been Disabled.",
            "success"
          );
          // Optionally redirect or refresh
          navigate(-1);
        } else {
          Swal.fire(
            "Error",
            response.data.message || "Something went wrong.",
            "error"
          );
        }
      } catch (error) {
        console.error("Disabled error:", error);
        Swal.fire("Error", "Failed to Disabled account.", "error");
      }
    }
  };





  const handleAllowAccount = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will Allow Login the seller account!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Allow it!",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await axios.post(
          `${baseurl}allowSellerById/${sellerData.seller.id}`
        );
        if (response.data.status === "success") {
          Swal.fire(
            "Deleted!",
            "The seller account has been Allowed Login.",
            "success"
          );
          // Optionally redirect or refresh
          navigate(-1);
        } else {
          Swal.fire(
            "Error",
            response.data.message || "Something went wrong.",
            "error"
          );
        }
      } catch (error) {
        console.error("Allow error:", error);
        Swal.fire("Error", "Failed to Allow account.", "error");
      }
    }
  };


  const [showUniqueId, setShowUniqueId] = useState(false);

  const renderSellerTable = (seller) => (
    <div className="card p-3">

      <div className="row mb-3 align-items-center">
  <label className="col-sm-3 col-form-label fw-bold text-dark">
    Approved Status
  </label>
  <div className="col-sm-9">
    {seller.approval ? (
      <span className="badge bg-success">Approved</span>
    ) : (
      <span className="badge bg-danger">Not Approved</span>
    )}
  </div>
</div>



      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Unique ID{" "}
          <span
            role="button"
            onClick={() => setShowUniqueId((prev) => !prev)}
            className="ms-2"
            style={{ cursor: "pointer" }}
          >
            {showUniqueId ? <EyeOff size={16} /> : <Eye size={16} />}
          </span>
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={showUniqueId ? seller.seller_unique_id : "••••••••••••"}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          First Name
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={seller.first_name}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Middle Name
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={seller.middle_name || "-"}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Last Name
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={seller.last_name}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Email
        </label>
        <div className="col-sm-9">
          <input
            type="email"
            className="form-control"
            value={seller.seller_email}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Phone
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={seller.phone}
            readOnly
          />
        </div>
      </div>



       <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Disabled
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={seller.disable}
            readOnly
          />
        </div>
      </div>

      {/* <div className="row mb-3 align-items-center">
    <label className="col-sm-3 col-form-label fw-bold text-dark">Country</label>
    <div className="col-sm-9">
      <input type="text" className="form-control" value={seller.country} readOnly />
    </div>
  </div> */}

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          OTP Verified
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={seller.otp_verified ? "Yes" : "Yes"}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Created At
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={new Date(seller.created_at).toLocaleString()}
            readOnly
          />
        </div>
      </div>
    </div>
  );

  const renderBusinessTable = (business) => (
    <div className="card p-3 mt-3">
      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Business Name
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={business.business_name}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Business Email
        </label>
        <div className="col-sm-9">
          <input
            type="email"
            className="form-control"
            value={business.business_email}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Contact
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={business.contact}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          GST Number
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={business.gst_number || "-"}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Business Address
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={business.business_address}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          City
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={business.city}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          State
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={business.state}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Country
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={business.country}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3 align-items-center">
        <label className="col-sm-3 col-form-label fw-bold text-dark">
          Pincode
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value={business.pincode}
            readOnly
          />
        </div>
      </div>

      {/* <div className="row mb-3 align-items-center">
      <label className="col-sm-3 col-form-label fw-bold text-dark">Created At</label>
      <div className="col-sm-9">
        <input
          type="text"
          className="form-control"
          value={new Date(business.created_at).toLocaleString()}
          readOnly
        />
      </div>
    </div>
  
    <div className="row mb-3 align-items-center">
      <label className="col-sm-3 col-form-label fw-bold text-dark">Updated At</label>
      <div className="col-sm-9">
        <input
          type="text"
          className="form-control"
          value={new Date(business.updated_at).toLocaleString()}
          readOnly
        />
      </div>
    </div> */}

      {business.gst_document && (
        <div className="row mb-3 align-items-center">
          <label className="col-sm-3 col-form-label fw-bold text-dark">
            GST Document
          </label>
          <div className="col-sm-9">
            <a
              href={`${imageUrl}gst_documents/${business.gst_document}`}
              target="_blank"
              className="form-control"
              download
            >
              View File
            </a>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <h4 className="mb-3">Seller Details</h4>

          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Spinner animation="border" />
            </div>
          ) : sellerData ? (
            <>
              <div className="row mb-4 g-2">
                <div className="col-md-8">
                  <div>
                    <Card className="shadow-sm p-3 mb-2">
                      <h5>Seller Info</h5>
                      <div>
                        <span
                          className="btn btn-primary text-white me-2"
                          role="button"
                          onClick={handleDeleteAccount}
                        >
                          <Trash2 className="me-1" /> Delete Account
                        </span>


                        

{sellerData.seller.disable === false ? (
  <span
    className="btn btn-warning text-dark me-2"
    role="button"
    onClick={handleDisabledAccount}
  >
    <EyeOff className="me-1" /> Restrict / Disable Login
  </span>
) : (
  <span
    className="btn btn-info text-dark"
    role="button"
    onClick={handleAllowAccount}
  >
    <EyeOff className="me-1" /> Allow Login
  </span>
)}


{!sellerData.seller.approval && (
  <span
    className="btn btn-success text-white me-2"
    role="button"
    onClick={handleApproveAccount}
  >
    <FaTicketAlt className="me-1" /> Approve Account
  </span>
)}




                      </div>

                      
                    </Card>
                  </div>

                  <Card className="shadow-sm p-3 mb-2">
                    <h5>Seller Info</h5>
                    {renderSellerTable(sellerData.seller)}
                  </Card>

                  <Card className="shadow-sm p-3">
                    <h5>Business Info</h5>
                    {sellerData.business ? (
                      renderBusinessTable(sellerData.business)
                    ) : (
                      <p>No business data found.</p>
                    )}
                  </Card>
                </div>
                <div className="col-md-4">
                  <Card className=" mb-2">
                    <div className="ag1 bgg2 p-2 text-start">
                      <div className="d-flex justify-content-between">
                        <div className="ag4 mb-2">
                          <span className="agsvg1 bbg2 p-2 py-3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="40px"
                              viewBox="0 -960 960 960"
                              width="40px"
                              fill="#FFFFFF"
                            >
                              <path d="M306.67-284q13.66 0 23.5-9.83 9.83-9.84 9.83-23.5 0-13.67-9.83-23.5-9.84-9.84-23.5-9.84-13.67 0-23.5 9.84-9.84 9.83-9.84 23.5 0 13.66 9.84 23.5Q293-284 306.67-284Zm0-162.67q13.66 0 23.5-9.83Q340-466.33 340-480t-9.83-23.5q-9.84-9.83-23.5-9.83-13.67 0-23.5 9.83-9.84 9.83-9.84 23.5t9.84 23.5q9.83 9.83 23.5 9.83Zm0-162.66q13.66 0 23.5-9.84Q340-629 340-642.67q0-13.66-9.83-23.5-9.84-9.83-23.5-9.83-13.67 0-23.5 9.83-9.84 9.84-9.84 23.5 0 13.67 9.84 23.5 9.83 9.84 23.5 9.84Zm128 325.33h242.66v-66.67H434.67V-284Zm0-162.67h242.66v-66.66H434.67v66.66Zm0-162.66h242.66V-676H434.67v66.67ZM186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h586.66q27 0 46.84 19.83Q840-800.33 840-773.33v586.66q0 27-19.83 46.84Q800.33-120 773.33-120H186.67Zm0-66.67h586.66v-586.66H186.67v586.66Zm0-586.66v586.66-586.66Z" />
                            </svg>
                          </span>
                        </div>

                        <div className="ag2 font4">
                          {sellerData.listingCount}
                        </div>
                      </div>

                      <div className="ag3 font4 d-flex justify-content-between">
                        <span>Total Listings</span>
                        <Link
                          to={`/admin/seller-all-listing/${sellerData.seller.id}`}
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                    {/* 
                    <h6 className="text-dark ag2 font4">Listing Count</h6>
                    <h4>{sellerData.listingCount}</h4> */}
                  </Card>

                  <Card className=" mb-2">
                    <div className="ag1 bgg2 p-2 text-start">
                      <div className="d-flex justify-content-between">
                        <div className="ag4 mb-2">
                          <span className="agsvg1 bbg2 p-2 py-3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="40px"
                              viewBox="0 -960 960 960"
                              width="40px"
                              fill="#FFFFFF"
                            >
                              <path d="M306.67-284q13.66 0 23.5-9.83 9.83-9.84 9.83-23.5 0-13.67-9.83-23.5-9.84-9.84-23.5-9.84-13.67 0-23.5 9.84-9.84 9.83-9.84 23.5 0 13.66 9.84 23.5Q293-284 306.67-284Zm0-162.67q13.66 0 23.5-9.83Q340-466.33 340-480t-9.83-23.5q-9.84-9.83-23.5-9.83-13.67 0-23.5 9.83-9.84 9.83-9.84 23.5t9.84 23.5q9.83 9.83 23.5 9.83Zm0-162.66q13.66 0 23.5-9.84Q340-629 340-642.67q0-13.66-9.83-23.5-9.84-9.83-23.5-9.83-13.67 0-23.5 9.83-9.84 9.84-9.84 23.5 0 13.67 9.84 23.5 9.83 9.84 23.5 9.84Zm128 325.33h242.66v-66.67H434.67V-284Zm0-162.67h242.66v-66.66H434.67v66.66Zm0-162.66h242.66V-676H434.67v66.67ZM186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h586.66q27 0 46.84 19.83Q840-800.33 840-773.33v586.66q0 27-19.83 46.84Q800.33-120 773.33-120H186.67Zm0-66.67h586.66v-586.66H186.67v586.66Zm0-586.66v586.66-586.66Z" />
                            </svg>
                          </span>
                        </div>
                        <div className="ag2 font4">
                          {sellerData.priceSummary.map((item) => (
                            <div key={item.currency}>
                              {parseFloat(item.total_price).toLocaleString(
                                "en-IN",
                                {
                                  style: "currency",
                                  currency: item.currency,
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="ag3 font4 d-flex justify-content-between">
                        <span>Total Listing Price</span>
                        <Link
                          to={`/admin/seller-all-listing/${sellerData.seller.id}`}
                        >
                          View All
                        </Link>
                      </div>
                    </div>

                    {/* <h6 className="text-muted">Total Price by Currency</h6>
                    {sellerData.priceSummary.map((item) => (
                      <div key={item.currency}>
                        <strong>{item.currency}:</strong>{" "}
                        {parseFloat(item.total_price).toLocaleString("en-IN", {
                          style: "currency",
                          currency: item.currency,
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </div>
                    ))} */}
                  </Card>




                  <Card className=" ">
                    <div className="ag1 bgg2 p-2 text-start">
                      <div className="d-flex justify-content-between">
                        <div className="ag4 mb-2">
                          <span className="agsvg1 bbg2 p-2 py-3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="40px"
                              viewBox="0 -960 960 960"
                              width="40px"
                              fill="#FFFFFF"
                            >
                              <path d="M306.67-284q13.66 0 23.5-9.83 9.83-9.84 9.83-23.5 0-13.67-9.83-23.5-9.84-9.84-23.5-9.84-13.67 0-23.5 9.84-9.84 9.83-9.84 23.5 0 13.66 9.84 23.5Q293-284 306.67-284Zm0-162.67q13.66 0 23.5-9.83Q340-466.33 340-480t-9.83-23.5q-9.84-9.83-23.5-9.83-13.67 0-23.5 9.83-9.84 9.83-9.84 23.5t9.84 23.5q9.83 9.83 23.5 9.83Zm0-162.66q13.66 0 23.5-9.84Q340-629 340-642.67q0-13.66-9.83-23.5-9.84-9.83-23.5-9.83-13.67 0-23.5 9.83-9.84 9.84-9.84 23.5 0 13.67 9.84 23.5 9.83 9.84 23.5 9.84Zm128 325.33h242.66v-66.67H434.67V-284Zm0-162.67h242.66v-66.66H434.67v66.66Zm0-162.66h242.66V-676H434.67v66.67ZM186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h586.66q27 0 46.84 19.83Q840-800.33 840-773.33v586.66q0 27-19.83 46.84Q800.33-120 773.33-120H186.67Zm0-66.67h586.66v-586.66H186.67v586.66Zm0-586.66v586.66-586.66Z" />
                            </svg>
                          </span>
                        </div>
                        <div className="ag2 font4">
                        {sellerData.anotherTableCount}
                        </div>
                      </div>
                      <div className="ag3 font4 d-flex justify-content-between">
                        <span>All Orders</span>
                        <Link
                          to={`/admin/seller-all-order/${sellerData.seller.id}`}
                        >
                          View All
                        </Link>
                      </div>
                    </div>
 
                  </Card>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6"></div>
              </div>
            </>
          ) : (
            <p>No seller data found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SellerDetail;
